export default {
    send: function (action, data = {}) {
        if (window.mixpanel && typeof(window.mixpanel.track) === 'function') {
            window.mixpanel.track(action, data)
        }
    }
}
